module.exports = __webpack_public_path__ + "./img/logo-punct.7e34af97f88929d97863c560d7d0f3a7.png";